function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n            fill-rule: evenodd;\n            }\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Rounded_Rectangle_1745",
  className: "cls-1",
  d: "M41,693H55a2,2,0,0,1,2,2v17a2,2,0,0,1-2,2H41a2,2,0,0,1-2-2V695A2,2,0,0,1,41,693Zm2,2H53a2,2,0,0,1,2,2v13a2,2,0,0,1-2,2H43a2,2,0,0,1-2-2V697A2,2,0,0,1,43,695Z",
  transform: "translate(-39 -693)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "Rounded_Rectangle_1749",
  className: "cls-2",
  x: 4,
  y: 5,
  width: 5,
  height: 2,
  rx: 1,
  ry: 1
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "Rounded_Rectangle_1749-2",
  className: "cls-2",
  x: 4,
  y: 9,
  width: 9,
  height: 2,
  rx: 1,
  ry: 1
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "Rounded_Rectangle_1750",
  className: "cls-2",
  x: 4,
  y: 13,
  width: 9,
  height: 2,
  rx: 1,
  ry: 1
});

function SvgIconReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_reports",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReports);
export default __webpack_public_path__ + "static/media/icon_reports.50a6c82b.svg";
export { ForwardRef as ReactComponent };